<!--
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description: 分页
-->
<template>
  <div class="pager">
    <el-pagination
      v-if="pager && Object.keys(pager).length > 0"
      @size-change="sizeChange"
      @current-change="pageChange"
      :current-page="pager.page"
      :page-size="pager.size"
      :page-sizes="pager.pageSizes"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pager.total"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'pagerCpt',
  components: {},
  props: {
    pager: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      pageSizes: []
    };
  },

  computed: {},

  created() {
    if (
      this.pager &&
      Object.keys(this.pager).length > 0 &&
      this.pager.pageSizes &&
      this.pager.pageSizes.length > 0
    ) {
      this.pageSizes = this.pager.pageSizes || ELEMENT.Pagination.props.pageSizes.default();
    }
  },

  methods: {
    sizeChange(val) {
      const page = JSON.parse(JSON.stringify(this.pager));
      page.page = 1;
      page.size = val;
      this.$emit('update:pager', page);
      this.$emit('getData');
    },
    pageChange(val) {
      const page = JSON.parse(JSON.stringify(this.pager));
      page.page = val;
      this.$emit('update:pager', page);
      this.$emit('getData');
    }
  }
};
</script>
<style lang="scss" scoped></style>
